import React, { forwardRef, memo } from 'react';
import { Typography } from '@cointervue/design-system/components';

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  rightIcon?: React.ReactNode;
  leftIcon?: React.ReactNode;
  onRightIconClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  label?: string;
  error?: string;
}

const CustomInput = memo(
  forwardRef<HTMLInputElement, CustomInputProps>(
    (
      {
        type,
        rightIcon,
        leftIcon,
        onRightIconClick,
        label,
        required,
        error,
        autoComplete,
        ...props
      },
      ref
    ) => {
      return (
        <div className="flex flex-col gap-1 w-full">
          {label && (
            <Typography as="label" variant="label">
              {label}{' '}
              {required && (
                <span className="text-brand-error-red text-xl align-middle">
                  *
                </span>
              )}
            </Typography>
          )}
          <div
            className={`flex items-center border rounded-lg px-3 py-1.5 ${
              error ? 'border-brand-error-red' : 'border-brand-gray-light'
            }`}
          >
            {leftIcon && (
              <span className="mr-2 text-brand-black-2">{leftIcon}</span>
            )}
            <input
              ref={ref}
              type={type}
              required={required}
              autoComplete={autoComplete}
              className="bg-transparent outline-none w-full text-brand-black placeholder-brand-black-2 text-sm h-6"
              {...props}
            />
            {rightIcon && (
              <span
                onClick={onRightIconClick}
                className="cursor-pointer text-brand-black-2"
              >
                {rightIcon}
              </span>
            )}
          </div>
          {error && <Typography variant="error">{error}</Typography>}
        </div>
      );
    }
  )
);
CustomInput.displayName = 'CustomInput'; //avoid forwardRef anonymous warning

export default CustomInput;
